import React from "react";
import { Box } from "@material-ui/core";
import { Info } from "@material-ui/icons";

const UnsavedChangesIndicator = ({ show }) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        right: 100,
        marginRight: 24,
        marginBottom: 12,
        padding: 6,
        backgroundColor: "#768FDD",
        color: "#ffffff",
        borderRadius: 12,
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "@media (max-width: 1100px)": {
          marginBottom: 60,
        },
      }}
    >
      <Info style={{ marginRight: "6px" }}></Info>
      Modifications non sauvegardées
    </Box>
  );
};

export default UnsavedChangesIndicator;
